<template>
    <Protocols
        :title="$gettext('Protokoly pro nelineární obsah')"
        :protocols="protocols"
        :protocol-ids="entity.protocol_order_nonlinear_content"
        :isEditable="isEditable"
        @addProtocol="onAddProtocol"
        @removeProtocol="onRemoveProtocol"
        @sortProtocols="onSortProtocols"
    />
</template>

<script>

import Protocols from "./Protocols";

export default {
    name: "NonLinearProtocols",
    components: {Protocols},
    props: {
        entity: Object,
        protocols: Array,
        isEditable: Boolean
    },
    methods: {
        onAddProtocol(newIdProtocol) {
            this.entity['protocol_order_nonlinear_content'] = [...this.entity['protocol_order_nonlinear_content'], newIdProtocol];

            if (!(newIdProtocol in this.entity['protocols'])) {
                this.$emit('addProtocol', newIdProtocol);
            }
        },
        onRemoveProtocol(deletedIdProtocol) {
            this.entity['protocol_order_nonlinear_content'] = this.entity['protocol_order_nonlinear_content'].filter((idProtocol) => idProtocol != deletedIdProtocol);
        },
        onSortProtocols(sortedProtocolIds) {
            this.entity['protocol_order_nonlinear_content'] = sortedProtocolIds;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceProfiles/forms/NonLinearProtocols.vue